/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentManagerUserGroupDashboardContentResponseLearningEvent } from './ContentManagerUserGroupDashboardContentResponseLearningEvent';
import {
    ContentManagerUserGroupDashboardContentResponseLearningEventFromJSON,
    ContentManagerUserGroupDashboardContentResponseLearningEventFromJSONTyped,
    ContentManagerUserGroupDashboardContentResponseLearningEventToJSON,
} from './ContentManagerUserGroupDashboardContentResponseLearningEvent';
import type { ContentManagerUserGroupDashboardContentResponsePublicOffer } from './ContentManagerUserGroupDashboardContentResponsePublicOffer';
import {
    ContentManagerUserGroupDashboardContentResponsePublicOfferFromJSON,
    ContentManagerUserGroupDashboardContentResponsePublicOfferFromJSONTyped,
    ContentManagerUserGroupDashboardContentResponsePublicOfferToJSON,
} from './ContentManagerUserGroupDashboardContentResponsePublicOffer';
import type { ContentManagerUserGroupSelfAssignableResponseAssignedContentsInner } from './ContentManagerUserGroupSelfAssignableResponseAssignedContentsInner';
import {
    ContentManagerUserGroupSelfAssignableResponseAssignedContentsInnerFromJSON,
    ContentManagerUserGroupSelfAssignableResponseAssignedContentsInnerFromJSONTyped,
    ContentManagerUserGroupSelfAssignableResponseAssignedContentsInnerToJSON,
} from './ContentManagerUserGroupSelfAssignableResponseAssignedContentsInner';
import type { ContentManagerUserGroupSelfAssignableResponsePermissions } from './ContentManagerUserGroupSelfAssignableResponsePermissions';
import {
    ContentManagerUserGroupSelfAssignableResponsePermissionsFromJSON,
    ContentManagerUserGroupSelfAssignableResponsePermissionsFromJSONTyped,
    ContentManagerUserGroupSelfAssignableResponsePermissionsToJSON,
} from './ContentManagerUserGroupSelfAssignableResponsePermissions';

/**
 * Creates a user group. kind defaults to 'elearning' when omitted; kind='blended_learning' additionally requires content_version_id and a learning_event hash (form, location, minimum_capacity, maximum_capacity, unlimited_capacity, coordinator_ids) - this creates the nested learning_event, assigns the content_version's content_in_company_space to the new group, and creates an internal order for it. Requires company space admin for kind=elearning, or the content's author or a company space admin for kind=blended_learning.
 * @export
 * @interface ContentManagerUserGroupCreateResponse
 */
export interface ContentManagerUserGroupCreateResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    external_id: string;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    is_default: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    user_count: number;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    content_count: number;
    /**
     * 
     * @type {Date}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    updated_at: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    self_assignable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    enrolled_by_current_user: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    kind: ContentManagerUserGroupCreateResponseKindEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    offer_type: ContentManagerUserGroupCreateResponseOfferTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    form: ContentManagerUserGroupCreateResponseFormEnum;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    content_version_name: string;
    /**
     * 
     * @type {Date}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    start_date: Date;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    days_count: number;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    minimum_capacity: number;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    maximum_capacity: number;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    time_estimation: number;
    /**
     * 
     * @type {ContentManagerUserGroupSelfAssignableResponsePermissions}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    permissions: ContentManagerUserGroupSelfAssignableResponsePermissions;
    /**
     * 
     * @type {boolean}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    billing_orders: boolean;
    /**
     * 
     * @type {Array<ContentManagerUserGroupSelfAssignableResponseAssignedContentsInner>}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    assigned_contents?: Array<ContentManagerUserGroupSelfAssignableResponseAssignedContentsInner>;
    /**
     * 
     * @type {ContentManagerUserGroupDashboardContentResponsePublicOffer}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    public_offer?: ContentManagerUserGroupDashboardContentResponsePublicOffer;
    /**
     * 
     * @type {ContentManagerUserGroupDashboardContentResponseLearningEvent}
     * @memberof ContentManagerUserGroupCreateResponse
     */
    learning_event?: ContentManagerUserGroupDashboardContentResponseLearningEvent;
}


/**
 * @export
 */
export const ContentManagerUserGroupCreateResponseKindEnum = {
    Elearning: 'elearning',
    BlendedLearning: 'blended_learning'
} as const;
export type ContentManagerUserGroupCreateResponseKindEnum = typeof ContentManagerUserGroupCreateResponseKindEnum[keyof typeof ContentManagerUserGroupCreateResponseKindEnum];

/**
 * @export
 */
export const ContentManagerUserGroupCreateResponseOfferTypeEnum = {
    PublicAndPrivate: 'public_and_private',
    Public: 'public',
    Private: 'private',
    None: 'none'
} as const;
export type ContentManagerUserGroupCreateResponseOfferTypeEnum = typeof ContentManagerUserGroupCreateResponseOfferTypeEnum[keyof typeof ContentManagerUserGroupCreateResponseOfferTypeEnum];

/**
 * @export
 */
export const ContentManagerUserGroupCreateResponseFormEnum = {
    Online: 'online',
    Combined: 'combined',
    InPerson: 'in_person',
    InPersonAndOnline: 'in_person_and_online'
} as const;
export type ContentManagerUserGroupCreateResponseFormEnum = typeof ContentManagerUserGroupCreateResponseFormEnum[keyof typeof ContentManagerUserGroupCreateResponseFormEnum];


/**
 * Check if a given object implements the ContentManagerUserGroupCreateResponse interface.
 */
export function instanceOfContentManagerUserGroupCreateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "external_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "is_default" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "user_count" in value;
    isInstance = isInstance && "content_count" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "self_assignable" in value;
    isInstance = isInstance && "enrolled_by_current_user" in value;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "offer_type" in value;
    isInstance = isInstance && "form" in value;
    isInstance = isInstance && "content_version_name" in value;
    isInstance = isInstance && "start_date" in value;
    isInstance = isInstance && "days_count" in value;
    isInstance = isInstance && "minimum_capacity" in value;
    isInstance = isInstance && "maximum_capacity" in value;
    isInstance = isInstance && "time_estimation" in value;
    isInstance = isInstance && "permissions" in value;
    isInstance = isInstance && "billing_orders" in value;

    return isInstance;
}

export function ContentManagerUserGroupCreateResponseFromJSON(json: any): ContentManagerUserGroupCreateResponse {
    return ContentManagerUserGroupCreateResponseFromJSONTyped(json, false);
}

export function ContentManagerUserGroupCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentManagerUserGroupCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'external_id': json['external_id'],
        'name': json['name'],
        'is_default': json['is_default'],
        'status': json['status'],
        'user_count': json['user_count'],
        'content_count': json['content_count'],
        'updated_at': (new Date(json['updated_at'])),
        'self_assignable': json['self_assignable'],
        'enrolled_by_current_user': json['enrolled_by_current_user'],
        'kind': json['kind'],
        'offer_type': json['offer_type'],
        'form': json['form'],
        'content_version_name': json['content_version_name'],
        'start_date': (new Date(json['start_date'])),
        'days_count': json['days_count'],
        'minimum_capacity': json['minimum_capacity'],
        'maximum_capacity': json['maximum_capacity'],
        'time_estimation': json['time_estimation'],
        'permissions': ContentManagerUserGroupSelfAssignableResponsePermissionsFromJSON(json['permissions']),
        'billing_orders': json['billing_orders'],
        'assigned_contents': !exists(json, 'assigned_contents') ? undefined : ((json['assigned_contents'] as Array<any>).map(ContentManagerUserGroupSelfAssignableResponseAssignedContentsInnerFromJSON)),
        'public_offer': !exists(json, 'public_offer') ? undefined : ContentManagerUserGroupDashboardContentResponsePublicOfferFromJSON(json['public_offer']),
        'learning_event': !exists(json, 'learning_event') ? undefined : ContentManagerUserGroupDashboardContentResponseLearningEventFromJSON(json['learning_event']),
    };
}

export function ContentManagerUserGroupCreateResponseToJSON(value?: ContentManagerUserGroupCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'external_id': value.external_id,
        'name': value.name,
        'is_default': value.is_default,
        'status': value.status,
        'user_count': value.user_count,
        'content_count': value.content_count,
        'updated_at': (value.updated_at.toISOString()),
        'self_assignable': value.self_assignable,
        'enrolled_by_current_user': value.enrolled_by_current_user,
        'kind': value.kind,
        'offer_type': value.offer_type,
        'form': value.form,
        'content_version_name': value.content_version_name,
        'start_date': (value.start_date.toISOString()),
        'days_count': value.days_count,
        'minimum_capacity': value.minimum_capacity,
        'maximum_capacity': value.maximum_capacity,
        'time_estimation': value.time_estimation,
        'permissions': ContentManagerUserGroupSelfAssignableResponsePermissionsToJSON(value.permissions),
        'billing_orders': value.billing_orders,
        'assigned_contents': value.assigned_contents === undefined ? undefined : ((value.assigned_contents as Array<any>).map(ContentManagerUserGroupSelfAssignableResponseAssignedContentsInnerToJSON)),
        'public_offer': ContentManagerUserGroupDashboardContentResponsePublicOfferToJSON(value.public_offer),
        'learning_event': ContentManagerUserGroupDashboardContentResponseLearningEventToJSON(value.learning_event),
    };
}

